export const RIGHT_ASIDE_WIDTH = 320;
